import PatientPdpaForm from './PatientPdpaForm'
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from 'react'
import { Row, Button, Col, Card, Tabs, Tab } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { Model, StylesManager } from 'survey-core'
import { Survey } from 'survey-react-ui'
import 'survey-core/defaultV2.min.css'
import { themeJson } from './theme2'
import FormLoading from 'components/Loader/FormLoading'
import { SurveyResults } from 'survey-creator-react'
//import * as SurveyTheme from "survey-core/themes";
import './index.scss'
import httpClient from 'utility/httpClient.util'
import Swal from 'sweetalert2'
import useAuth from 'hooks/useAuth'
import { debounceCallback } from 'utility/debounceCallback.util'
import { useLockEdit } from 'contexts/PatientLockEditProvider'
import { transferTemplate,getLangList } from 'designer/menu/assessment/SummaryTemplate'
import 'survey-creator-core/survey-creator-core.css'
import { useTranslation } from 'react-i18next'
//import { json } from "./json";
//StylesManager.applyTheme("defaultV2");

const getSummaryTemplateValue = (template, language = 'default') => {
  if (!template) return ''
  if (typeof template === 'string') return template
  if (typeof template !== 'object') return ''

  return template[language] || template.default || ''
}
const emptySyncedValues = {}
const noop = () => {}

const AssessmentForm = forwardRef((props, ref) => {
  const {
    form,
    debounceName='create-json-answer',
    preferLang='default',
    setLangOption=()=>{},
    hideFooter = false,
    onClose = () => {},
    onSaveCallback = () => {},
    onValueChanged = noop,
    syncedValues = emptySyncedValues,
  } = props
  const { i18n } = useTranslation()
  const currentLanguage = i18n.language
  const { user } = useAuth()
  const { isLocked } = useLockEdit()
  const surveyRef = useRef(null)
  const isDirtyRef = useRef(false)
  const [surveyJson, setSurveyJson] = useState(null)
  const [jsonAnswer, setJsonAnswer] = useState(null)
  const [formCode, setFormCode] = useState(null)
  const [showSummary, setShowSummary] = useState(false)
  const [active, setActive] = useState('summaryResult')
  const [summaryValue, setSummaryValue] = useState(null)
  const [summaryTemplate, setSummaryTemplate] = useState(null)

  const getElements = (element) => {
    return Array.isArray(element?.elements) ? element.elements : []
  }

  const createJsonAnswer = async (form) => {
    // Fetch JSON from network
    const bindData = {}
    if (form.code) {
      const result = await httpClient
        .get(`/designer/form-assessment/search?code=${form.code}`)
        .then(({ data }) => data)
        .catch(() => {})
      const jsonData = result?.data?.jsonData
      setSurveyJson(jsonData)
      setSummaryTemplate(result?.data?.summaryTemplate)
      //Finding Service then Value
      setLangOption(getLangList(jsonData) || ['default'])
      const cache = {}
      for (const page of jsonData?.pages || []) {
        for (const element of getElements(page)) {
          if (element.bindModel) {
            //bindData[element.name] = element.bindField;
            bindData[element.name] = await requestBindData(
              cache,
              element.bindModel,
              element.bindField
            )
          } else if (element.type === 'panel') {
            for (const pelement of getElements(element)) {
              if (pelement.bindModel) {
                bindData[pelement.name] = await requestBindData(
                  cache,
                  pelement.bindModel,
                  pelement.bindField
                )
              }
            }
          }
        }
      }
    }
    let jsonData = bindData
    if (form.code && form.patientAssessmentId && form.patientAssessmentId > 0) {
      const result = await httpClient
        .get(`/clinical/patient-assessment/${form.patientAssessmentId}`)
        .then(({ data }) => data)
        .catch(() => {})

      jsonData = Object.assign(result?.data?.jsonData || {}, bindData)
    } else {
      jsonData = Object.assign({}, bindData)
    }
    isDirtyRef.current = false
    setJsonAnswer(jsonData)
  }

  useEffect(() => {
    debounceCallback(createJsonAnswer, [form], debounceName)
  }, [debounceName, form])

  const survey = useMemo(() => {
    if (!surveyJson || jsonAnswer === null) return null

    const model = new Model(surveyJson)
    model.data = jsonAnswer
    return model
  }, [surveyJson, jsonAnswer])

  useEffect(() => {
    if (!survey) return () => {}

    const handleValueChanged = (_sender, options) => {
      isDirtyRef.current = true
      onValueChanged(options?.name, options?.value)
    }

    survey.onValueChanged.add(handleValueChanged)

    Object.entries(syncedValues).forEach(([name, value]) => {
      if (
        value !== undefined &&
        value !== null &&
        value !== '' &&
        survey.getValue(name) !== value
      ) {
        survey.setValue(name, value)
      }
    })

    return () => survey.onValueChanged.remove(handleValueChanged)
  }, [onValueChanged, survey, syncedValues])

  const requestBindData = async (cache, model, field) => {
    if (cache[model]) {
      return cache[model][field] || ''
    }
    try {
      if (model === 'patient') {
        const result =
          (await httpClient.get(`/pas/patient-basic-info?hn=${form.hn}`))
            ?.data || {}
        cache[model] = result.data
        //console.log('r',result.data)
        return result?.data[field] || ''
      }
    } catch (error) {
      return ''
    }
  }

  const onSave = async (options = {}) => {
    const showNotification = options?.showNotification !== false

    if (isLocked) {
      const message = 'Could not save in Readonly Mode'

      if (showNotification) Swal.fire('Error !', message, 'error')

      return { success: false, message }
    }

    //Validate Require Fields
    const currentSurvey = surveyRef.current?.survey || survey

    if (!currentSurvey) {
      const message = 'แบบประเมินยังไม่พร้อม กรุณาลองใหม่อีกครั้ง'

      if (showNotification) Swal.fire('Error !', message, 'warning')

      return { success: false, message }
    }

    const surveyValues = currentSurvey.valuesHash || currentSurvey.data || {}
    console.log('s', surveyValues)
    setJsonAnswer(surveyValues)
    const surveyAnswer = { ...surveyValues }
    // var validate = survey.validate();
    // if (!validate) {
    //     // Display an error message to the user or prevent submission
    //     Swal.fire('Error !', 'โปรดตรวจสอบฟิลด์ที่มีเครื่องหมายดอกจัน (*) เนื่องจากจำเป็นต้องกรอกข้อมูล', 'error')
    //     return;
    // }
    let resultSummary = []
    let resultRemark = []
    const jsonData = surveyJson
    const findResultInPanel = (element, answer) => {
      const elements = getElements(element)
      if (elements.length === 0) {
        return []
      }
      const list = []
      for (const pelement of elements) {
        if (pelement.showOnSummary && pelement.showOnSummary === true) {
          const valueName = pelement.valueName || pelement.name
          let valueText = answer?.[valueName] || ''
          if (pelement.type === 'checkbox' && Array.isArray(valueText)) {
            valueText = valueText.map((item) => {
              let text = ''
              for (const choice of pelement.choices) {
                if (choice.value === item) text = choice.text
              }
              return text
            })
          }
          let summary = {
            label: pelement.title,
            valueItem: answer?.[valueName],
            value: valueText,
            type: pelement.type,
            valueName: valueName,
            name: pelement.name,
          }

          list.push(summary)
        } else if (pelement.showOnRemark && pelement.showOnRemark === true) {
          if (pelement.type === 'html') resultRemark.push(pelement)
        } else if (pelement.type && pelement.type === 'panel') {
          const valueName = pelement.valueName || pelement.name
          console.log('panel', valueName, answer?.[valueName])
          return findResultInPanel(pelement, answer)
        } else if (pelement.type === 'paneldynamic') {
          const valueName = pelement.valueName || pelement.name
          const valueList = Array.isArray(answer?.[valueName])
            ? answer[valueName]
            : []
          console.log('jsonDynamicPanel', valueName, answer?.[valueName])
          for (const anPanel of valueList) {
            const aList = findResultInPanel(
              { ...pelement, elements: pelement.templateElements },
              anPanel
            )
            let summary = {
              label: pelement.title,
              valueItem: answer?.[valueName],
              value: aList,
              type: pelement.type,
              valueName: valueName,
              name: pelement.name,
            }
            list.push(summary)
          }
        }
      }
      return list
    }
    for (const page of jsonData?.pages || []) {
      const list = findResultInPanel(page, surveyAnswer)
      resultSummary = resultSummary.concat(list)
    }

    const summaryTemplateValue = getSummaryTemplateValue(
      summaryTemplate,
      preferLang,
    )
    if (summaryTemplateValue) {
      resultSummary.push({
        name: 'summaryTemplate',
        type: 'html',
        label: '',
        value: transferTemplate(
          surveyJson,
          summaryTemplateValue,
          surveyAnswer,
          preferLang,
        ),
      })
    }

    const postObj = {
      assessmentCode: form.code,
      assessmentName: form.name,
      formAssessmentId: form.formAssessmentId,
      hn: form.hn,
      an: form?.an,
      vn: form.vn,
      jsonData: surveyAnswer,
      resultSummary: { summary: resultSummary, remark: resultRemark },
      //updatedById:user.email
    }

    let result = null
    if (form.patientAssessmentId && form.patientAssessmentId > 0) {
      result = await httpClient
        .put(
          '/clinical/patient-assessment/' + form.patientAssessmentId,
          postObj
        )
        .then((result) => result)
        .catch((e) => e)
    } else {
      result = await httpClient
        .post('/clinical/patient-assessment', postObj)
        .then((result) => result)
        .catch((e) => e)
    }

    console.log('save', result)
    if (result?.status >= 200 && result?.status < 300) {
      if (showNotification) {
        Swal.fire({
          title: 'Save Success',
          icon: 'success',
          timer: 1000, // 2 seconds
          showConfirmButton: false,
        })
      }
      isDirtyRef.current = false
      onSaveCallback(result, {
        assessment: result?.data?.data || result?.data || {},
        jsonData: surveyAnswer,
        resultSummary: postObj.resultSummary,
        surveyJson,
      })
      onClose()
      return { success: true, result }
    } else {
      console.log('e', result)
      const message =
        result?.response?.data?.message ||
        result?.data?.message ||
        result?.message ||
        'ไม่สามารถบันทึก Assessment ได้'

      if (showNotification) {
        Swal.fire('Error ! บันทึกไม่สำเร็จ', message, 'error')
      }

      return { success: false, message }
    }
  }

  const handleComplete = (sender) => {
    //console.log("sender",sender)
    console.log(JSON.stringify(sender.data, null, 3))
    if (isLocked) {
      Swal.fire('Error ! Could not save in Readonly Mode', '', 'error')
    } else {
      onSave()
    }
  }

  const handleCompleting = (sender, options) => {
    // Prevent the survey from completing by setting options.allowComplete to false
    // Add your custom logic here to determine when to allow completion
    options.allowComplete = !isLocked
    if (isLocked) {
      Swal.fire('Error ! Could not save in Readonly Mode', '', 'error')
    }
  }

  const renderCompleted = () => {
    return <div>hello Complete</div>
  }

  const onSummaryResult = () => {
    if (!showSummary) {
      const currentSurvey = surveyRef.current?.survey || survey
      const surveyValues =
        currentSurvey?.valuesHash || currentSurvey?.data || {}
      const summaryTemplateValue = getSummaryTemplateValue(
        summaryTemplate,
        preferLang,
      )

      console.log('s', surveyValues)
      setJsonAnswer(surveyValues)
      setSummaryValue(
        summaryTemplateValue
          ? transferTemplate(
              surveyJson,
              summaryTemplateValue,
              surveyValues,
              preferLang,
            )
          : '',
      )
    }

    setShowSummary(!showSummary)
  }

  useImperativeHandle(ref, () => ({
    isDirty: () => isDirtyRef.current,
    save: (options) => onSave(options),
  }))

  if (!survey) {
    return <FormLoading />
  }

  return (
    <Row className="assessment-form assessment-form--compact no-gutters">
      <Col xs={12} className="assessment-form__survey">
        <Survey
          ref={surveyRef}
          model={survey}
          locale={preferLang || 'default'}
          showCompletedPage={false}
          renderCompleted={renderCompleted}
          onComplete={handleComplete}
          onCompleting={handleCompleting}
        />
      </Col>
      {showSummary && (
        <Col md={12}>
          <Tabs
            id="controlled-tab-result"
            className="mb-3"
            onSelect={(key) => setActive(key)}
          >
            <Tab eventKey="summaryResult" title="Summary Result">
              <div contentEditable="false" className="content-editable">
                <div dangerouslySetInnerHTML={{ __html: summaryValue }} />
              </div>
            </Tab>
            <Tab eventKey="tableResult" title="Table Result">
              {active === 'tableResult' && <SurveyResults survey={survey} />}
            </Tab>
          </Tabs>
        </Col>
      )}
      {!hideFooter && (
        <Col
          md={12}
          className="assessment-form__footer d-flex justify-content-between align-items-center m-t-10"
        >
          {/* "Summary Result" button on the left */}
          <Button onClick={onSummaryResult} variant="info" className="mr-3">
            <i className="feather icon-list mr-1" />
            Summary Result
          </Button>

          {/* Existing buttons on the right */}
          <div className="assessment-form__footer-actions text-right">
            <Link
              to="#"
              className="mr-3 text-muted"
              onClick={(event) => {
                event.preventDefault()
                onClose()
              }}
            >
              <i className="feather icon-x mr-1" /> Cancel
            </Link>
            {!isLocked && (
              <>
                <Button onClick={onSave} className="m-r-10">
                  <i className="feather icon-stop-circle mr-1" />
                  Complete
                </Button>
                <Button onClick={onSave} variant="success">
                  <i className="feather icon-lock mr-1" />
                  Lock Edit
                </Button>
              </>
            )}
          </div>
        </Col>
      )}
    </Row>
  )

  // return (
  //   <Row>
  //     <Col>
  //       <Card>
  //         <Card.Header>
  //           <Card.Title>Survey</Card.Title>
  //         </Card.Header>
  //         <Card.Body>
  //           <Survey ref={surveyRef} model={survey}
  //             showCompletedPage={false}
  //             onValueChanged={(e) => getSurveyValue(e)}
  //           />
  //         </Card.Body>
  //       </Card>
  //     </Col>
  //   </Row>
  // );
})

const AssessmentFormRouter = forwardRef((props, ref) =>
  props.form?.code === 'patient-pdpa' ? (
    <PatientPdpaForm {...props} ref={ref} />
  ) : (
    <AssessmentForm {...props} ref={ref} />
  )
)

export default AssessmentFormRouter
